/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./logo.css";
import NewsHighlights from "../Carousel/carousel";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function LogoSection() {
  const [articlelogoData, setArticleLogoData] = useState();
  const imgCDNURL = process.env.REACT_APP_CDN_IMAGES;
  const imgURL = process.env.REACT_APP_ANGELAI_IMAGES;
  const isDesktop = window.innerWidth > 768; // Adjust the breakpoint as needed
  const carouselRef = useRef(null);

  useEffect(() => {
    let isMounted = true; // Variable to track component mount status
    const fetchPublicationJSON = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_LOGOCAROUSEL);
        if (isMounted) {
          setArticleLogoData(response.data);
        }
        
      } catch (error) {
        console.log(error);
      }
    };
    fetchPublicationJSON();
    return () => {
      isMounted = false; // Mark the component as unmounted when cleanup is called
    };
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (carouselRef.current) {
        carouselRef.current.slickGoTo(0, true);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
   
    const handleTouchMove = (e) => {
      if (!isDesktop && carouselRef.current) {
        const carouselNode = carouselRef.current.innerSlider.list;

        if (carouselNode.contains(e.target)) {
          e.preventDefault();
        }
      }
    };

    window.addEventListener("touchmove", handleTouchMove, { passive: false });
    return () => {
      window.removeEventListener("touchmove", handleTouchMove);
    };
  }, [isDesktop]);

  const carouselSettings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3500,
    slidesToShow: isDesktop ? 5 : 3,
    slidesToScroll: 1,
    swipeToSlide: isDesktop,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  };

  return (
    <>
      <div className="logoSection">
        <Container className="breakingNews">
          {articlelogoData ? (
            <Slider {...carouselSettings} ref={carouselRef}>
              {articlelogoData.publications.map((item, k) => (
                <div key={k} className="logoSlide">
                  <a href={item.url} target="_blank" rel="noopener noreferrer">
                    <Image
                      src={item.logo}
                      className="logoimg"
                      alt={item.name}
                      title={item.name}
                    />
                  </a>
                </div>
              ))}
            </Slider>
          ) : (
            ""
          )}
        </Container>
        <Container className="videocontainer">
          <Row>
            <Col sm={12} className="foxvideosection">
              <NewsHighlights />
            </Col>
          </Row>
        </Container>
      </div>
      
    </>
  );
}